import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { signInUser, updateMe } from 'Actions';
import { useEffect } from 'react';
import Api from 'Api';
import { useIntl } from 'react-intl';

const SignInWithToken = () => {
  const [searchParams, _] = useSearchParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { formatMessage } = useIntl();

  useEffect(() => {
    _signin(searchParams, dispatch, navigate, formatMessage);
  }, []);

  return <></>;
};

const _signin = async (searchParams, dispatch, navigate, formatMessage) => {
  const token = searchParams.get('token');
  const type = searchParams.get('type');
  const field = searchParams.get('field');
  if (!token) {
    navigate('/', { replace: true });
  } else {
    await dispatch(signInUser({ token }, navigate, type, field));
    try {
      const meResult = await Api.auth.me();
      if (meResult.err) {
        if (meResult.err.response.data === 'UN_AUTHORIZED_ADMIN_IP') {
          alert(`${formatMessage({ id: 'common.notIpAreaText' })}`);
        }
        return;
      }
      await dispatch(updateMe(meResult.data));
    } catch (e) {
      navigate('/', { replace: true });
      window.location.reload();
    }
  }
};

export default SignInWithToken;
